module.exports = __webpack_public_path__ + "static/img/surpass_limit.bfca08bf.png";